var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.045 12.25c0 1.25 1.67 2.108 3.333 3.437 1.107.886 1.648 2.324 1.621 4.313H6.001c-.027-1.989.513-3.427 1.621-4.313 1.662-1.329 3.334-2.187 3.334-3.437v-.499c0-1.249-1.672-2.108-3.334-3.437C6.514 7.428 5.974 5.99 6.001 4H18.999c.027 1.99-.514 3.428-1.621 4.314-1.663 1.329-3.333 2.188-3.333 3.437v.499zm2.335 6.45c0-1.932-1.77-3.5-3.954-3.5S8.47 16.769 8.47 18.7h7.91z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgress);
export default __webpack_public_path__ + "static/media/progress.99c530881f7f4291dec3fd9f0110511f.svg";
export { ForwardRef as ReactComponent };